import { APIFieldType } from '@ardoq/api-types';
import { TAGS_FIELD_NAME } from '@ardoq/data-model';
import { getDefaultAttributeLabelForComponent } from '@ardoq/renderers';

export const DEFAULT_FIELDS = [
  { name: 'component-key', type: APIFieldType.TEXT, deselectedByDefault: true },
  {
    name: 'created-by',
    type: APIFieldType.USER,
    deselectedByDefault: true,
  },
  { name: 'created', type: APIFieldType.DATE_TIME, deselectedByDefault: true },
  {
    name: 'last-modified-by',
    type: APIFieldType.USER,
    deselectedByDefault: false,
  },
  {
    name: 'lastUpdated',
    type: APIFieldType.DATE_TIME,
    deselectedByDefault: false,
  },
  { name: 'type', type: APIFieldType.TEXT, deselectedByDefault: true },
  {
    name: TAGS_FIELD_NAME,
    type: APIFieldType.LIST,
    deselectedByDefault: false,
  },
].map((field, i) => ({
  _id: `default-field-${i}`,
  label: getDefaultAttributeLabelForComponent(field.name) || field.name,
  _order: i,
  ...field,
}));
